import { applySystemFavicon } from '@/lib/favicon';

// Sets the favicon for the OS color scheme as soon as the page loads, before
// React mounts (ThemeContext keeps it in sync after that). This was an inline
// <script> in index.html; it lives in a file so the CSP can drop 'unsafe-inline'
// from script-src (SEC-25).
applySystemFavicon();
